const Form103EN = {
    stepName: {
        importantNotes: "Important Notes",
        collectionMeans: "Collection of e-contact Means",
        confirmation: "Confirmation",
    },

    importantNotesContent: {
        statement:
            "I have read, understood and agreed to the above terms and conditions.",
        termsConditions:
            'I understand the applicant need to have an "iAM Smart+" account to process the application.',
    },
    note: {
        supervisorEmail: "(for receiving electronic license)",
        supervisorTel: "(for telephone communication and receiving SMS)",
        schoolCode: "(Only applicable to registered school)",
        receiveSMSChecked:
            "I certify that the information given in this reply slip are true and complete. I hereby confirm that I have read through the content of ‘Personal Information Collection Statement’ and understand that with respect to school registration and related matters, the EDB may issue electronic notification (e.g. issuing the electronic ‘Certificate of Registration of a School or Certificate of Provisional Registration of a School’ upon approval granted) to me through the above e-contact means, i.e. SMS and/or email, as and when necessary. If I do not wish to receive these SMS messages, I would tick the box below. Otherwise, I will be regarded as willing to receive the SMS messages.",
    },

    collectionMeans: {
        label: {
            schoolName: "School Name",
            schoolAddress: "School Address",
            supervisorTitle: "Title of School Supervisor",
            supervisorName: "Name of School Supervisor",
            supervisorEmail: "Email Address of School Supervisor",
            supervisorTel: "Mobile Phone Number of School Supervisor",
            schoolCode: "School Number ",
            receiveSMSChecked:
                "I do not wish to receive SMS messages with respect to the school registration and related matters.",
            receiveSMSNo:
                "I wish to receive SMS messages with respect to the school registration and related matters.",
        },
        errorMsg: {
            supervisorName: "Please input a valid Supervisor Name",
            schoolCode: "The School Number must be 6 digits",
        },
        option: {
            titleOption: {
                Mr: "Mr",
                Miss: "Miss",
                Ms: "Ms",
                Mrs: "Mrs",
            },
        },
    },
};
export default Form103EN;
